/**
 * @generated SignedSource<<f6f74499644150a541ed93b5894b85c1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type reviewersFilter_softwareCodePage$data = ReadonlyArray<{
  readonly reviewers: ReadonlyArray<{
    readonly user: {
      readonly accountId: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "reviewersFilter_softwareCodePage";
}>;
export type reviewersFilter_softwareCodePage$key = ReadonlyArray<{
  readonly " $data"?: reviewersFilter_softwareCodePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"reviewersFilter_softwareCodePage">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "reviewersFilter_softwareCodePage",
  "selections": [
    {
      "concreteType": "DevOpsReviewer",
      "kind": "LinkedField",
      "name": "reviewers",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountId"
            },
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "kind": "ScalarField",
              "name": "picture"
            }
          ]
        }
      ]
    }
  ],
  "type": "DevOpsPullRequestDetails"
};

(node as any).hash = "4bb009caf2b19a77410c9d90ad2ee61f";

export default node;
